"use client"

import { Avatar, Box, Card, HStack, Marquee, Stack } from '@chakra-ui/react';
import { IoStar } from 'react-icons/io5';

interface Testimonial {
  name: string
  role: string
  rating: number
  avatar: string
  content: string
}

const testimonials: Testimonial[] = [
  {
    name: "Robert",
    role: "- kurs maturalny",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?u=a042581f4e29026024d",
    content:
      "Szczerze polecam, miło się z „Opanujem” pracuje. Do matury jak znalazł!",
  },
  {
    name: "Marta",
    role: "- korepetycje indywidualne",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?u=a042581f4e29026704d",
    content:
      "Bardzo polecam, wyniki przeszły moje najśmielsze oczekiwania.",
  },
  {
    name: "Mama Ignacego",
    role: "– kurs ósmoklasisty",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?u=a04258114e29026302d",
    content:
      "Z państwa pomocą mój syn wszystkie egzaminy zaliczył na 100%.",
  },
  {
    name: "Jakub",
    role: "",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?u=a042581f4e29026024d",
    content:
      "Super! Syn wreszcie wraca zadowolony z zajęć!!!.",
  },
  {
    name: "Iwona",
    role: "",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?u=a04258a2462d826712d",
    content:
      "Z całego serca polecam korepetycje w Opanuj.to.",
  },
  {
    name: "Anna",
    role: "",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?u=a04258a2462d826712d",
    content:
      "Bardzo, bardzo polecam! Prowadzący podchodzą z rzetelnością i dokładnością do swoich podopiecznych, a sami właściciele przesympatyczni i kontaktowi. :)",
  },
]

const TestimonialCard = ({ item }: { item: Testimonial }) => {
  return (
    <Card.Root maxW="sm" h="full">
      <Card.Body>
        <Stack gap="3">
          <HStack gap="1">
            {[...Array(5)].map((_, i) => (
              <Box as={IoStar} key={i} color="orange.solid" />
            ))}
          </HStack>

          <Card.Description color="fg.muted" textStyle="md" minH="16">
            „{item.content}”
          </Card.Description>

          <HStack gap="3" mt="1">
            <Avatar.Root size="sm">
              {/* <Avatar.Image src={item.avatar} /> */}
              <Avatar.Fallback name={item.name} />
            </Avatar.Root>
            <Box textStyle="sm">
              <Box fontWeight="medium" color="fg">
                {item.name}
              </Box>
              <Box color="fg.muted">{item.role}</Box>
            </Box>
          </HStack>
        </Stack>
      </Card.Body>
    </Card.Root>
  )
}

export const HomeTestimonials = () => {
  return (
  <Marquee.Root pauseOnInteraction py="10">
    <Marquee.Edge side="start" />
    <Marquee.Viewport>
      <Marquee.Content>
        {testimonials.map((item, i) => (
          <Marquee.Item key={i} px="1rem">
            <TestimonialCard item={item} />
          </Marquee.Item>
        ))}
      </Marquee.Content>
    </Marquee.Viewport>
    <Marquee.Edge side="end" />
  </Marquee.Root>
  )
}


